import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Typography } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAssignOrdersToAnotherCompanyMutation } from "src/_api/orderApi";

export default function AssignOrdersToAnotherCompanyDialog({
    orderIds,
    sxProps,
    onRefersh
}) {
    const { t } = useTranslation()
    const [assignOrdersToAnotherCompany, { isLoading, isSuccess, error, reset }] = useAssignOrdersToAnotherCompanyMutation()
    const [open, setOpen] = useState(false)

    const assignOrdersToAnotherCompanyHandler = async () => {
        try {
            await assignOrdersToAnotherCompany({ name: "MOMENT", orderIds }).unwrap()
            onRefersh()
            setTimeout(() => {
                setOpen(false)
            }, 2000);
        } catch (error) {

        }
    }

    useEffect(() => {
        if (open) {
            reset()
        }
    }, [open])

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                disabled={!orderIds?.length}
                variant="contained"
                sx={{ textTransform: "none", ...sxProps }}
            >
                {t("Assign to shipping company")}
            </Button>
            <Dialog open={open} onClose={(e) => e.preventDefault()} fullWidth>
                {/* <DialogTitle>
                {t("Assign orders to another company")}
            </DialogTitle>
            <Divider /> */}
                <DialogContent>
                    {t("Assign orders to another company")}
                    {/* <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t("Select company")}</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={name}
                        label={t("Select company")}
                        onChange={(event) => setName(event.target.value)}
                    >
                        {
                            OUT_SOURCE_COMPANY.map(el => (
                                <MenuItem value={el.name}>{el.name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl> */}
                </DialogContent>
                <Divider />
                <DialogActions>
                    {!!error && <Typography color="error">{t(error)}</Typography>}
                    {!!isSuccess && <Typography color="green.main">{t("Done successfully")}</Typography>}
                    <Box mr="auto" />
                    <Button onClick={() => setOpen(false)} variant="contained" sx={{ textTransform: "none" }}>{t("Close")}</Button>
                    <LoadingButton
                        loading={isLoading}
                        onClick={assignOrdersToAnotherCompanyHandler}
                        // disabled={!name}
                        variant="contained"
                        sx={{ textTransform: "none" }}
                    >
                        {t("Confirm")}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
